function hasNumericPrice(value) {
  return value !== null && value !== undefined && value !== "" && Number.isFinite(Number(value));
}

function hasListablePrice(value) {
  return hasNumericPrice(value) && Number(value) > 0;
}

export function getDefaultListingMode(card) {
  return Boolean(card?.foil) ? "foiltrend" : "trend";
}

export function getResolvedListingOption(card, listingOptions = {}) {
  const storedMode = String(card?.pricing_mode || "").trim().toLowerCase();
  const defaultMode = ["trend", "foiltrend", "custom"].includes(storedMode)
    ? storedMode
    : getDefaultListingMode(card);

  return {
    mode: defaultMode,
    customPrice: defaultMode === "custom" ? String(card?.sale_price ?? card?.user_price ?? "") : "",
    ...(listingOptions?.[card?.id] || {})
  };
}

export function getListingPriceForCard(card, listingOptions = {}) {
  const option = getResolvedListingOption(card, listingOptions);

  if (option.mode === "custom") {
    const customPrice = Number(option.customPrice);
    return Number.isFinite(customPrice) && customPrice > 0 ? customPrice : Number.NaN;
  }

  const catalogPrice = Boolean(card?.foil) ? card?.price_foil : card?.price_trend;
  return hasListablePrice(catalogPrice) ? Number(catalogPrice) : Number.NaN;
}